<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/newsletter' }">
        <app-i18n code="entities.newsletter.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.newsletter.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.newsletter.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-newsletter-view-toolbar v-if="record"></app-newsletter-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>

        <app-view-item-text :label="fields.lastname.label" :value="presenter(record, 'lastname')"></app-view-item-text>

        <app-view-item-text :label="fields.email.label" :value="presenter(record, 'email')"></app-view-item-text>

        <app-view-item-text :label="fields.zipcode.label" :value="presenter(record, 'zipcode')"></app-view-item-text>

        <app-view-item-text :label="fields.state.label" :value="presenter(record, 'state')"></app-view-item-text>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NewsletterViewToolbar from '@modules/newsletter/components/newsletter-view-toolbar.vue';
import { NewsletterModel } from '@modules/newsletter/newsletter-model';

const { fields } = NewsletterModel;

export default {
  name: 'app-newsletter-view-page',

  props: ['id'],

  components: {
    [NewsletterViewToolbar.name]: NewsletterViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'newsletter/view/record',
      loading: 'newsletter/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'newsletter/view/doFind',
    }),

    presenter(record, fieldName) {
      return NewsletterModel.presenter(record, fieldName);
    },
  },
};
</script>
